var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseMenuBadgesLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/security"
  }, /*#__PURE__*/React.createElement("g", {
    id: "security"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.22 3.78L4.39334 11.6067C4.10001 11.9 3.60668 11.86 3.36668 11.5133C2.54001 10.3067 2.05334 8.88 2.05334 7.41334V4.48667C2.05334 3.94 2.46668 3.32 2.97334 3.11334L6.68668 1.59334C7.52668 1.24667 8.46001 1.24667 9.30001 1.59334L12 2.69334C12.44 2.87334 12.5533 3.44667 12.22 3.78Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.8467 4.69333C13.28 4.32667 13.94 4.64 13.94 5.20667V7.41333C13.94 10.6733 11.5734 13.7267 8.34004 14.62C8.12005 14.68 7.88004 14.68 7.65338 14.62C6.70671 14.3533 5.82671 13.9067 5.07338 13.32C4.75338 13.0733 4.72005 12.6067 5.00005 12.32C6.45338 10.8333 10.7067 6.5 12.8467 4.69333Z",
    fill: "#CCCCCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseMenuBadgesLocked);
export default __webpack_public_path__ + "static/media/course_menu_badges_locked.f1903ac46d5b7fb8aebfa883b2e1b5e2.svg";
export { ForwardRef as ReactComponent };